/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateActivityProductsSchema } from "./updateActivityProductsSchema.ts";

export const updateActivitySchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string(),
	sizes: z.array(z.uuid()),
	products: z.array(updateActivityProductsSchema),
	snapshotHash: z.string().max(64).nullish(),
});
